import { FC, forwardRef } from 'react';
import cn from 'classnames';
import useStyles from './FolderCard.styles';

export interface FolderCardThumbnailProps {
  isDark?: boolean;
}

export const FolderCardThumbnail: FC<FolderCardThumbnailProps> = (
  { isDark },
  ref,
) => {
  const classes = useStyles();

  return (
    <div
      ref={ref}
      className={cn(
        classes.thumbnailImage,
        isDark && classes.thumbnailImageDark,
      )}
    />
  );
};

// @ts-ignore
export default forwardRef(FolderCardThumbnail);
